import { FormTagsInput } from '@components/form';
import * as yup from 'yup';

export const volumeTagsSchema = yup.array().of(yup.string());

export const VolumeTagsField = () => {
  return <FormTagsInput label="Tags" name="tags" />;
};
